<template>
    <van-popup
        v-model:show="asideStore.isShow"
        position="left"
        :overlay="true"
        :close-on-click-overlay="true"
        :style="{ width: '75%', height: '100%' }"
        :overlay-style="{ backgroundColor: 'rgba(0, 0, 0, 0.3)' }"
    >
        <div class="w-full h-full flex flex-col items-center max-h-screen bg-gray-50 overflow-y-auto">
            <header class="flex flex-row items-center justify-between w-full h-12 bg-white shadow-md p-2">
                <button @click="asideStore.hideAside()">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        fill="currentColor"
                    >
                        <path d="M18 18V20H6V18H18ZM21 11V13H3V11H21ZM18 4V6H6V4H18Z"></path>
                    </svg>
                </button>
                <button @click="handleToNewChat">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        fill="currentColor"
                    >
                        <path
                            d="M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM10 3H14V5H10C6.68629 5 4 7.68629 4 11C4 14.61 6.46208 16.9656 12 19.4798V17H14C17.3137 17 20 14.3137 20 11H22C22 15.4183 18.4183 19 14 19V22.5C9 20.5 2 17.5 2 11C2 6.58172 5.58172 3 10 3Z"
                        ></path>
                    </svg>
                </button>
            </header>
            <main class="w-full flex-1 p-2 overflow-y-auto">
                <div
                    v-for="item in chatStore.chatListArray"
                    :key="item[0]"
                    class="p-2 rounded border-b flex items-center justify-between cursor-pointer hover:bg-gray-100"
                    :class="item[0] == Number(route?.query?.chatId) ? 'bg-gray-100' : ''"
                    @click="
                        () => {
                            asideStore.hideAside();
                            chatStore.changeChat(item[0]);
                        }
                    "
                >
                    {{ item[1].chat_name ?? '新聊天' }}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="16"
                        height="16"
                        fill="currentColor"
                        @click.stop="chatStore.deleteChat(item[0])"
                    >
                        <path
                            d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z"
                        ></path>
                    </svg>
                </div>
            </main>
            <footer class="w-full border-t-2">
                <van-popover placement="right-end" :actions="actions" @select="onSelect">
                    <template #reference>
                        <div class="w-full flex flex-row items-center p-2">
                            <van-image
                                class="rounded-full mr-2"
                                style="width: 40px; height: 40px"
                                :src="userData?.avatarUrl"
                                cross-origin="anonymous"
                                @error="
                                    e => {
                                        e.target.src = 'logo.png';
                                    }
                                "
                            />
                            <span>{{ userData?.username }}</span>
                        </div>
                    </template>
                </van-popover>
            </footer>
        </div>
    </van-popup>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';

import { useRoute } from 'vue-router';
import type { PopoverAction } from 'vant';
import useAside from '../store/useAside';
import useChat from '../store/useChat';
import { getUserInfoFromStorage } from '../utils/storage';
import router from '../router';

const route = useRoute();
const userData = getUserInfoFromStorage();
const asideStore = useAside();
const chatStore = useChat();

const toMine = () => {
    if (userData?.userType !== 'admin') {
        return;
    }
    asideStore.hideAside();
    router.push('/admin');
};
const actions: PopoverAction[] = [
    {
        text: '退出登录',
        fn: () => {
            // console.log('退出登录');
            localStorage.clear();
            router.push('/login');
        },
    },
    {
        text: '进入管理员界面',
        disabled: userData?.userType !== 'admin',
        fn: () => {
            toMine();
        },
    },
];
const onSelect = (action: PopoverAction) => {
    action.fn?.();
};

const handleToNewChat = () => {
    asideStore.hideAside();
    chatStore.newChat();
};

onMounted(() => {
    console.log('aside mounted');
    console.log(chatStore.chatListArray);
});
</script>

<style scoped>
:deep(.van-popover__action) {
    width: auto;
}
</style>
